module.exports = __webpack_public_path__ + "img/copy-icons.8fb3fa8c.svg";